/* Zumpo/Letter key. */
.key {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 56px;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: var(--zumpo-radius-8);
  box-shadow:
    var(--zumpo-shadow-cell-edge),
    inset 0 0 0 1px var(--zumpo-line);
  background: var(--zumpo-paper);
  color: var(--zumpo-ink);
  cursor: pointer;
  touch-action: manipulation;
}

.wide {
  width: 64px;
}

.compact {
  width: 30px;
  height: 44px;
}

.compact.wide {
  width: 47px;
}

@container (max-width: 471px) {
  .key {
    width: 30px;
    height: 44px;
  }

  .wide {
    width: 47px;
  }

  .letter {
    font: var(--zumpo-text-label);
    letter-spacing: var(--zumpo-text-label-tracking);
  }
}

/* A key that shares its row: the Digit pad on a phone, Regular height. */
.key.fill {
  flex: 1 1 0;
  width: auto;
  min-width: 0;
  height: 56px;
}

.fill .letter {
  font: var(--zumpo-text-number);
  letter-spacing: var(--zumpo-text-number-tracking);
}

.letter {
  font: var(--zumpo-text-number);
  letter-spacing: var(--zumpo-text-number-tracking);
}

.word,
.compact .letter {
  font: var(--zumpo-text-label);
  letter-spacing: var(--zumpo-text-label-tracking);
}

.correct {
  box-shadow: var(--zumpo-shadow-cell-edge);
  background: var(--zumpo-green);
  color: var(--zumpo-paper);
}

.present {
  border-radius: var(--zumpo-radius-999);
  box-shadow: var(--zumpo-shadow-cell-edge);
  background: var(--zumpo-coral);
}

.absent {
  box-shadow: none;
  background: var(--zumpo-line);
}

/* Out of the code for certain, which the game worked out, not the player:
   flat on the cream, its digit muted, still a key to press. */
.ruledOut {
  box-shadow: inset 0 0 0 1px var(--zumpo-line);
  background: var(--zumpo-cream);
  color: var(--zumpo-muted);
}

@media (hover: hover) {
  .plain:hover:not([aria-disabled='true']) {
    box-shadow:
      var(--zumpo-shadow-cell-edge),
      inset 0 0 0 2px var(--zumpo-ink);
  }
}

.key:focus-visible {
  outline: var(--focus-ring) solid var(--zumpo-ink);
  outline-offset: var(--focus-ring);
}

/* aria-disabled, not disabled: a key that was focused keeps the focus. */
.key[aria-disabled='true'] {
  cursor: not-allowed;
  /* As a disabled Button. */
  opacity: 0.45;
}
